import { Input } from '@mgmresorts/wcl-lab';
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';

import { useContent } from '../../../hooks/useContent';
import { MaxLengths } from '../../../utils/constants';
import { SignUpFormContext } from '../SignUpFormContext';
import { useFieldErrorAnalytics } from '../useFieldErrorAnalytics';

const StyledContent = styled.div`
  margin-top: 24px;
`;

export function EmailInput() {
  const { bindEmail, invalidFields } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();
  useFieldErrorAnalytics({ field: 'email', invalidFields });

  const error = useMemo(
    (): string | undefined =>
      invalidFields.includes('email') ? getContentByPath('accountCreation.fields.email.error') : undefined,
    [getContentByPath, invalidFields],
  );

  return (
    <StyledContent>
      <Input
        label={getContentByPath('accountCreation.fields.email.title')}
        id='email'
        disabled
        className={`identity__field ${error ? 'with-error' : ''}`}
        aria-label={getContentByPath('accountCreation.fields.email.label')}
        error={!!error}
        hint={error}
        testId='email'
        {...bindEmail}
        maxLength={MaxLengths.Email}
        domProps={{ 'data-lpignore': true }}
      />
    </StyledContent>
  );
}

EmailInput.displayName = 'EmailInputField';
